import { render, staticRenderFns } from "./ListCell.vue?vue&type=template&id=70c80bc2&"
import script from "./ListCell.vue?vue&type=script&lang=js&"
export * from "./ListCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports